import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useDeepDiveApi() {
    const callApi = useApiCall()

    const getInsightOverview = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.DEEP_DIVE.INSIGHT_OVERVIEW, data, onSuccess, onError)
    }

    const getAvgMetric = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.DEEP_DIVE.AVG_METRIC, data, onSuccess, onError)
    }

    return {
        getInsightOverview,
        getAvgMetric,
    }
}
